
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import { formatBool } from "@/utils";
import { EditStockAdjustmentDetail } from "@/models/api/barcodeSystem/stockAdjustments/edit";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class StockAdjustmentDetail extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  editStockAdjustmentDetail: EditStockAdjustmentDetail;

  @Prop({ default: null })
  facilityCode: string;

  @Prop({default: null})
  validationMessages: string[];

  get damageCodeOptions() : Array<any> {
    return barcodeSystemModule.damageCodes ?
      barcodeSystemModule.damageCodes.map(x => ({ label: x.description, value: x.code })) :
      [];
  }  
  
  formatBool(val)
  {
    formatBool(val)
  }

  handleDamagedChanged() {
    if(!this.editStockAdjustmentDetail.isDamaged)
    {
      this.editStockAdjustmentDetail.damageCode = null;
    }
  }
}
